<div class="space-y-2 text-grey text-sm">
  <p *ngIf="offer?.name">{{ offer.name }}</p>

  <div *ngIf="numberOfAdults" class="flex justify-between">
    <p>x {{ numberOfAdults }} {{ 'booking.offer.adults' | translate }}</p>

    <p>
      {{ adultsTotalPrice | displayPrice: subscription?.item.currency }}
    </p>
  </div>

  <div *ngIf="numberOfChildren" class="flex justify-between">
    <p>x {{ numberOfChildren }} {{ 'booking.offer.children' | translate }}</p>

    <p>
      {{ childrenTotalPrice | displayPrice: subscription?.item.currency }}
    </p>
  </div>
</div>

<div *ngIf="promoCode" class="space-y-2 mt-2 text-grey text-sm">
  <div class="flex">
    <p class="w-full">
      {{ 'checkout.promocode.infos.discount' | translate }} :
      {{ promoCode.label }}
    </p>

    <p class="whitespace-nowrap">
      -
      {{ promoCode.discountAmount | displayPrice: subscription?.item.currency }}
    </p>
  </div>
</div>

<div class="flex justify-between mt-2 font-bold">
  <p>{{ 'booking.offer.total' | translate }}</p>

  <p class="text-right">
    {{ totalPrice | displayPrice: subscription?.item.currency }}
  </p>
</div>
